import clsx from 'clsx'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import { searchPaneInteractEventName } from '../utils'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { containerLarge } from 'styles/vendor/bootstrap/variables'

export const TourSearchContainerPaneContent = styled.div`
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

export const TourSearchContainerPaneRoot = styled(Pane)`
  display: none;
  background-color: unset;

  &.display-mobile {
    display: flex;
    flex-direction: column;
  }

  ${mediaQueryUp.tablet} {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    transform:translateY(50%);
    z-index: 2;
    max-width: calc(${containerLarge} - ${rem(32)});
    width: 100%;
  }
`

interface Props extends React.ComponentProps<typeof TourSearchContainerPaneRoot> {
  displayMobile?: boolean
}

function TourSearchContainerPane(props: Props) {
  const {
    children,
    className,
    displayMobile,
    ...rest
  } = props

  const onInteract = useCallback(() => {
    document.dispatchEvent(new CustomEvent(searchPaneInteractEventName))
  }, [])

  return <TourSearchContainerPaneRoot
    {...rest}
    className={clsx(className, { 'display-mobile': displayMobile })}
    onClick={onInteract}
    onFocus={onInteract}
  >
    {children}
  </TourSearchContainerPaneRoot>
}

export default TourSearchContainerPane
